import { memo } from 'react';
import { NavLink } from 'react-router-dom';

const InternalLink = NavLink;

export default memo(InternalLink);
